import { REQUEST_REGISTATION, REGISTATION_STATUS, ERROR_REGISTATION, CLEAR_REGISTATION_INFO} from '../constants';

export default (state={}, action) => {
    switch(action.type){
        case REQUEST_REGISTATION:
            return {
                ...state,
                loading: true,
                response: null
            }
        case REGISTATION_STATUS: 
            return {
                ...state,
                loading: false,
                response: action.res,
                resStatus: action.res && action.res.status && action.res.status 
            }
        case ERROR_REGISTATION: 
            return {
                ...state,
                loading: false,
                err: true,
                errInfo: action.err,
                response: null,
                resStatus: null
            }
        case CLEAR_REGISTATION_INFO: 
            return {}
        default: return state
    }
}